let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bLl7w")).then(() => parcelRequire('lAHi1'));